import { createSlice } from '@reduxjs/toolkit';

// Initial state for admin fields
const initialState = {
  email: '',
  password: '',
  admin: null,
  token: null,
};
const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAuthField: (state, action) => {
      const { key, val } = action.payload;
      state[key] = val; 
    },
    initializeAuthFields: (state) => {
      state.email = '';
      state.password = '';
    },
   
    setAdmin: (state, action) => {
      state.admin = action.payload;
    },
    
    setToken: (state, action) => {
      state.token = action.payload;
    },
    // Log out the admin (reset fields and admin info)
    logoutAdmin: (state) => {
      state.email = '';
      state.password = '';
      state.admin = null;
      state.token = null;
    },
  },
});

export const { setAuthField, initializeAuthFields, setAdmin, setToken, logoutAdmin } = adminSlice.actions;

export default adminSlice.reducer;
